<template>
  <span v-html="$icons.get('times', 'medium')"></span>
</template>

<script>
export default { 
  name: 'Deselect'
}
</script>
